import React from "react";

const ProductGrid = ({ blocksData, handleItemClick, handleSaveClick, handleSpecialBlockClick }) => {
  const getColor = (colour) => {
    const colorMap = {
      Red: "#EE6055",
      Blue: "#83D3F2",
      Green: "#ADF7B6",
      Lavender: "#BDB2FF",
      Peach: "#FFC89A",
    };
    return colorMap[colour] || colour || "#83D3F2";
  };

  return (
    <div className="container-fluid p-2">
      <div className="row g-2">
        {blocksData.map((block, index) => {
          if (index === 48) {
            return (
              <div key={index} className="col-4 col-sm-3">
                <div
                  className="ratio ratio-1x1 rounded d-flex align-items-center justify-content-center"
                  style={{ backgroundColor: "#28a745", color: "white", cursor: "pointer" }}
                  onClick={handleSaveClick}
                >
                  <div className="fw-bold">BILL</div>
                </div>
              </div>
            );
          }

          if (index === 42) {
            return (
              <div key={index} className="col-4 col-sm-3">
                <div
                  className="ratio ratio-1x1 rounded d-flex align-items-center justify-content-center"
                  style={{ backgroundColor: "#007bff", color: "white", cursor: "pointer" }}
                  onClick={() => handleSpecialBlockClick(index)}
                >
                  <div className="fw-bold">QTY</div>
                </div>
              </div>
            );
          }

          if (index === 43) {
            return (
              <div key={index} className="col-4 col-sm-3">
                <div
                  className="ratio ratio-1x1 rounded d-flex align-items-center justify-content-center"
                  style={{ backgroundColor: "#ffc107", color: "black", cursor: "pointer" }}
                  onClick={() => handleSpecialBlockClick(index)}
                >
                  <div className="fw-bold">PRICE</div>
                </div>
              </div>
            );
          }

          if (!block.isSet) {
            return (
              <div key={index} className="col-4 col-sm-3">
                <div
                  className="ratio ratio-1x1 rounded d-flex align-items-center justify-content-center pos-empty-product-card"
                  style={{
                    backgroundColor: "transparent",
                    border: "1px dashed rgba(148, 163, 184, 0.22)",
                    opacity: 0.35,
                  }}
                >
                  <div className="pos-empty-slot-number">{index + 1}</div>
                </div>
              </div>
            );
          }

          return (
            <div key={index} className="col-4 col-sm-3">
              <div
                className="ratio ratio-1x1 rounded d-flex flex-column align-items-center justify-content-center p-2 pos-product-card"
                style={{ backgroundColor: getColor(block.colour), cursor: "pointer" }}
                onClick={() => handleItemClick(block)}
              >
                <div className="text-center small fw-semibold text-truncate w-100 pos-product-card-title">{block.title}</div>
                <div className="badge bg-dark bg-opacity-25 mt-1" style={{ fontSize: '0.7rem' }}>₹{parseFloat(block.price).toFixed(2)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductGrid;
